exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dashboard[data-v-26d16699]{margin-top:28px;min-height:calc(100vh - 53px);display:flex}", ""]);

// exports
